import CustomButton from "@components/buttons/CustomButton";
import SlidingPanel from "@components/sliders/SlidingPanel";
import { primeServices } from "@services/apis/Prime";
import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import useSnackbarMessage from "../../../utils/HandleSuccessErrorSnackbars";

interface ConfirmCadExpirePanelProps {
  open: boolean;
  instanceId?: string;
  onClose: () => void;
  onSuccess?: (instanceId: string) => void;
}

const ConfirmCadExpirePanel = ({
  open,
  instanceId,
  onClose,
  onSuccess,
}: ConfirmCadExpirePanelProps) => {
  const { handleError, handleSuccess } = useSnackbarMessage();
  const [loading, setLoading] = useState(false);
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const handleExpire = async () => {
    if (!instanceId) return;
    setLoading(true);
    try {
      const response = await primeServices.cadExpireInstance(instanceId);
      handleSuccess({
        message:
          response?.msg ||
          "Instance expiresAt updated to now. It will expire shortly.",
      });
      onSuccess?.(instanceId);
      onClose();
    } catch (error: any) {
      handleError({
        message:
          error?.response?.data?.msg ||
          error?.message ||
          "Failed to expire instance",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <SlidingPanel
      isOpen={open && !!instanceId}
      onClose={loading ? () => {} : onClose}
      onClickCross={loading ? () => {} : onClose}
      heading="Confirm Expire"
      showConfirm={false}
      showCross={!loading}
      isMobile={isMobile}
    >
      <div className="p-4 flex flex-col gap-4">
        <p className="text-xs text-text-subtle">
          You are about to expire instance{" "}
          <strong className="text-text-base">{instanceId}</strong>. This is
          available only while the order is at event 1. It will expire shortly.
          Do you want to continue?
        </p>
        <div className="flex flex-col gap-2">
          <CustomButton
            text="EXPIRE"
            isActive={true}
            isButtonLoading={loading}
            onClick={handleExpire}
            buttonColor="bg-bg-button-delete"
            borderColor="border-border-button-delete"
          />
          <CustomButton
            text="CANCEL"
            isActive={!loading}
            isHollow
            onClick={onClose}
          />
        </div>
      </div>
    </SlidingPanel>
  );
};

export default ConfirmCadExpirePanel;
